<template>
  <div class="attendance-report">
    <div class="table-container">
      <table v-if="resultData && resultData.length > 0" class="attendance-table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Total Marks</th>
            <th>Marks Obtained</th>
            <th>Percentage</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in resultData" :key="index" :class="{ 'even-row': index % 2 === 0 }">
            <td>
              <div class="d-flex align-items-center gap-2">
                <b>{{ item.title }}</b>
              </div>
            </td>
            <td>{{ item.total_marks }}</td>
            <td class="text-capitaliaze">{{ item.marks_obtained }}</td>
            <td class="text-capitaliaze">{{ item.percentage }}</td>
          </tr>
        </tbody>
      </table>
      <div v-else-if="loading || loadingResults" class="loading">
      <b-spinner small></b-spinner>
    </div>
      <div v-else class="text-center text-muted">
      No assignment data available. <br>
    </div>
    </div>
   
   
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { ContentType } from '../../../constants/content';
export default {
  name: 'AssignmentResult',
  props: {
    studentId: { type: String, required: true },
    productVariantId: { type: String, required: true },
  },
  data() {
    return {
      contents: [],
      assignmentResults: {},
      loading: false,
      loadingResults: false,
      resultData: [],
    };
  },
  methods: {
    ...mapActions("content", ["fetchContentListByProductVariant"]),
    ...mapActions("assignment", ["getProductvariantAssignmentResults"]),
    async fetchContentList() {
      try {
        this.loading = true;
        const res = await this.fetchContentListByProductVariant({
          id: this.productVariantId,
          contentType: ContentType.ASSIGNMENT,
        });
        this.contents = res || [];
      } catch (error) {
        console.error('Error fetching content list:', error);
      } finally {
        this.loading = false;
      }
    },

    async fetchProductVariantAssignmentResults() {
      try {
        this.loadingResults = true;
        const results = await this.getProductvariantAssignmentResults({
          productvariantId: this.productVariantId,
          studentId: this.studentId,
        });

        if (results) {
          results.forEach((val) => {
            this.assignmentResults[val.content.id] = val;
          });
          this.loadingResults = false;
        }
      } catch (error) {
        console.error("Error fetching assignment results:", error);
        this.loadingResults = false;
      }
    },

    buildResultData() {
      this.resultData = this.contents.map((content) => {
        let extraProps = {};
        try {
          extraProps = JSON.parse(content.extraProperties || "{}");
        } catch (e) {
          console.warn("Invalid extraProperties JSON", e);
        }

        const result = this.assignmentResults[content.id];

        return {
          title: content.title,
          total_marks: extraProps.Marks || "-",
          marks_obtained: result ? (result.isGraded ? result.marks : "pending") : "pending",
          percentage: result ? (result.isGraded ? result.percentage + "%" : "pending") : "pending",
        };
      });
    }
  },

  async created() {
    await this.fetchContentList();
    await this.fetchProductVariantAssignmentResults();
    this.buildResultData();
  },
};
</script>


<style scoped>
.attendance-report {
  padding: 1rem 0;
  padding-top: 0;
}

  .table-container {
      overflow-x: auto;
      border-radius: 0 !important;
      max-height: 80vh;
    }

.attendance-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.attendance-table tr:hover {
  background: #f2f2f2 !important;
}

.attendance-table th,
.attendance-table td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.attendance-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #2c3e50;
  position: sticky;
  top: 0;
  z-index: 1;
}

.attendance-table tr.even-row {
  background: #f9f9f9;
}

.attendance-table tr:hover {
  background: #e0f7fa;
  transition: background 0.3s ease;
}

.attendance-table td {
  color: #34495e;
  font-size: 1rem;
}

.text-muted {
  color: #7f8c8d;
}

.content-type-icon {
  height: 2rem;
}

.text-capitaliaze{
  text-transform: capitalize;
}
.loading{
    display: flex;
    justify-content: center;
    margin: 2rem;
    color: var(--primary-color);
  }

@media (max-width: 767px) {
  .attendance-table th,
  .attendance-table td {
    padding: 0.75rem;
    font-size: 0.9rem;
  }
}
</style>